// extracted by mini-css-extract-plugin
export default {"container":"hc6JS","content":"pRYaD","sidePanel":"LR279","withSidePanel":"NuXLV"};